<ng-container *ngIf="quotation">
  <div [innerHtml]="quotation.quotation | markdown" class="quotation"></div>
  <div [innerHtml]="source | markdown" class="source"></div>
</ng-container>
